import React, { useState, useEffect, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import LinearProgress from "@mui/material/LinearProgress";
import { format, parseISO } from "date-fns";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import MarketCapitalization from "../ProductPortfolio/MarketCapitalization/MarketCapitalization";
import Top5Sectors from "./Top5Sectors/Top5Sectors";
import pieChart1 from "../../../images/pie-chart-1.png";
import pieChart2 from "../../../images/pie-chart-2.png";
import animation from "../../../images/jm-animation.gif";

function ProductPortfolio(props) {
  const [data, setData] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [dataInd, setDataInd] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeCode = props.SchemeCode;

  const plan =
    props.SchemePlans && props.SchemePlans.trim() !== ""
      ? props.SchemePlans
      : "Direct";

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetTop10Holdings", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetFundIndicators", {
      IVSchemeCode: getSchemeCode,
      IVSchemePlan: plan,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataInd(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetFundAllocation", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        const decrypted = DecryptAESdata(data.data);
        setDataAll(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);

  const chunkSize = 5;
  const chunks = [];
  for (let i = 0; i < (data && data.length); i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  return (
    <>
      <section className="product_portfolio-sc" id="portfolio">
        <div className="flex-asondate">
          <div className="section-heading">Portfolio</div>
          {data &&
            getDistinctValuesAsDict(data, "AsonDate").map(
              ({ AsonDate, index }) => (
                <p key={index} className="text-left DateAson">
                  <span className="">As on - </span>
                  {AsonDate != null
                    ? format(parseISO(AsonDate), "do MMM, yyyy")
                    : ""}
                </p>
              ),
            )}
        </div>
    
         {Array.isArray(dataAll) &&
          dataAll.length > 0 &&
          dataAll[0]?.FundCode !== "AA" &&
          dataAll.map(({ CashHolding, EquityHolding }, index) => (
                  <>

                  <p>
                    <span style={{marginTop : "2rem"}} >Current Allocation </span>
                  </p>

                  <ul className="tab-links">
                    <li className="active">
                      <img src={pieChart1} alt="pie-chart1" />
                      Equity {EquityHolding} %
                    </li>
                    <li>
                      <img src={pieChart2} alt="pie-chart2" />
                      Debt/Cash {CashHolding} %
                    </li>
                  </ul>

                  <LinearProgress variant="determinate" value={EquityHolding} aria-label={`Equity allocation ${EquityHolding}%`}/>
                  </>
         
          ))}
        {Array.isArray(dataAll) &&
          dataAll.length > 0 &&
          dataAll[0]?.FundCode !== "AA" && (
            <div className="gradiant-head-flex">
              <MarketCapitalization getSchemeCode={getSchemeCode} />
              <Top5Sectors getSchemeCode={getSchemeCode} />
            </div>
          )}
        {/* Top 10 Holdings  */}
        <>
          {/*
                <div className="gradiant-head-flex">
                    <div className="gradiant-head-box">
                        <div className="gradiant-head-container">
                            <h3 className="gradiant-head left">Top 10 Holdings</h3>
                        </div>
                        <div className="gradiant-content">
                            <div className="padding-box-inner">
                                <div className="portfolioHold">
                                    {/* {(chunks.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} 
                                    {loadingshow ? (
                                        <div className="textcentervertex HomeLoader">
                                            <img src={animation} alt="Loading" />
                                            <div className="model_popup">Please Wait...</div>
                                        </div>
                                    ) : (
                                        <div className="holdDiv">
                                            {chunks.length === 0 ? (
                                                <h5 className="errormsgComNew">Since this is a new scheme, Holdings data is not yet available
</h5>
                                            ) : (
                                                <>
                                                    {chunks.map((chunk, index) => (
                                                        <div key={index} className="top10Holdings">
                                                            {chunk.map((item, itemIndex) => (
                                                                <>
                                                                    <div class="d-flex justify-content-between mb-1">
                                                                        <p class="holding-progress-text pr-sm-4">{item.IssuerLongName}</p>
                                                                        <p class="holding-progress-text percentHolding">{item.PercentToAss}%</p>
                                                                    </div>
                                                                    <LinearProgress variant="determinate" value={item.PercentToAss} />
                                                                    <br></br>
                                                                </>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {/* {loadingshow ? <div className="textcentervertex">
                                    <img src={animation} alt="Loading" />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                } 
                            </div>
                        </div>
                    </div>
                </div>
                */}
        </>
        <div className="gradiant-head-flex">
          <div className="gradiant-head-box">
            <div className="gradiant-head-container">
              <h3 className="gradiant-head left">Indicators</h3>
            </div>
            <div className="gradiant-content">
              <div className="fund-flex">
                {loadingshow ? (
                  <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true"/>
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  <div>
                    {!dataInd || dataInd?.length === 0 ? (
                      <h5 className="errormsgComNew">
                        Since this is a new scheme, Indicators data is not yet
                        available
                      </h5>
                    ) : (
                      <>
                        {dataInd && dataInd.length > 0 ? (
                          Array.isArray(dataInd) &&
                          dataInd.map(
                            ({
                              StdDev,
                              Beta,
                              Sharpe,
                              AvgMaturity,
                              Duration,
                              ModifiedDuration,
                              YTM,
                              PortfolioTurnoverRatio,
                              FundCode,
                            }) => (
                              <div className="fund-flex-indicator">
                                {PortfolioTurnoverRatio != null ? (
                          //         <ul>
                          //           <div className="sub-head portt ">
                          //             <h6 className="hover-fund">
                          //               {" "}
                          //               Portfolio Turnover Ratio
                          //             </h6>
                          //             <li>{(PortfolioTurnoverRatio).toLocaleString("en-IN", {
                          //   minimumFractionDigits: 2,
                          //   maximumFractionDigits: 2,
                          // })}</li>
                          //           </div>
                          //         </ul>
                          <ul className="Hoverul">
                          <li className="sub-head portt">
                            <p className="hover-fund">
                              Portfolio Turnover Ratio
                            </p>
                            <span>
                              {PortfolioTurnoverRatio.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </li>
                        </ul>
                                ) : (
                                  ""
                                )}
                                {StdDev != null ? (
                          //         <ul className="Hoverul">
                          //           <div className="sub-head text-wrap">
                          //             <h6 className="hover-fund">
                          //               {" "}
                          //               Standard Deviation
                          //               <span className="hover-text-summary">
                          //                 Standard deviation is a statistical
                          //                 measure of the range of an
                          //                 investment’s performance. When a
                          //                 mutual fund has a high standard
                          //                 deviation, its means its range of
                          //                 performance is wide, implying greater
                          //                 volatility
                          //               </span>
                          //             </h6>
                          //           </div>
                          //           <li>{(StdDev).toLocaleString("en-IN", {
                          //   minimumFractionDigits: 2,
                          //   maximumFractionDigits: 2,
                          // })}</li>
                          //         </ul>

                          <ul className="Hoverul">
                      <li>
                <div className="sub-head text-wrap">
                  <p className="hover-fund">
                    Standard Deviation
                    <span className="hover-text-summary">
                      Standard deviation is a statistical measure of the range of an investment’s performance. When a mutual fund has a high    standard deviation, its means its range of performance is wide, implying greater volatility
                    </span>
                  </p>
                </div>
                <span>
                  {StdDev.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </li>
            </ul>
                                ) : (
                                  ""
                                )}
                                {Beta != null ? (
                                  <ul className="Hoverul">
                                    <li>
                                    <div className="sub-head text-wrap">
                                      <p className="hover-fund tooltip-align">
                                        Beta
                                        <span className="hover-text-summary">
                                          Beta (β) is a measure of the
                                          volatility—or systematic risk—of a
                                          security or portfolio compared to the
                                          market as a whole. Stocks with betas
                                          higher than 1.0 can be interpreted as
                                          more volatile than the S&P.
                                        </span>
                                      </p>
                                    </div>
                                    </li>
                                    <li>{(Beta).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}</li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                                {Sharpe != null ? (
                                  <ul className="Hoverul">
                                    <li>
                                    <div className="sub-head text-wrap">
                                      <p className="hover-fund tooltip-align">
                                        Sharpe
                                        <span className="hover-text-summary">
                                          The Sharpe Ratio, named after its
                                          founder, the Nobel Laureate William
                                          Sharpe, is a measure of risk-adjusted
                                          returns. It is calculated using
                                          standard deviation and excess return
                                          to determine reward per unit of risk
                                        </span>
                                      </p>
                                    </div>
                                    </li>
                                    <li>{(Sharpe).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}</li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                                {AvgMaturity != null ? (
                                  <ul className="Hoverul">
                                    <div className="sub-head text-wrap">
                                      <h6>Average Maturity</h6>
                                    </div>
                                    <li className="productsub">
                                      {console.log(FundCode, "coooddddde")}
                                      <span>
                                         {(AvgMaturity).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                                        {FundCode === "FF" ||
                                        FundCode === "IF" ||
                                        FundCode === "SD" ||
                                        FundCode === "LD" ||
                                        FundCode === "AA" ||
                                        FundCode === "BF"
                                          ? " Years"
                                          : FundCode === "LF" ||
                                              FundCode === "ON"
                                            ? " Days"
                                            : ""}
                                      </span>
                                    </li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                                {Duration != null ? (
                                  <ul className="Hoverul">
                                    <div className="sub-head text-wrap">
                                      <h6>Duration</h6>
                                    </div>
                                    <li>
                                      <span>{(Duration).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} 
                                        {FundCode === "FF" ||
                                        FundCode === "IF" ||
                                        FundCode === "SD" ||
                                        FundCode === "LD" ||
                                        FundCode === "AA" ||
                                        FundCode === "BF"
                                          ? " Years"
                                          : FundCode === "LF" ||
                                              FundCode === "ON"
                                            ? " Days"
                                            : ""}
                                      </span>
                                    </li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                                {ModifiedDuration != null ? (
                                  <ul className="Hoverul">
                                    <div className="sub-head text-wrap">
                                      <p className="hover-fund tooltip-align">
                                        Modified Duration
                                        <span className="hover-text-summary">
                                          Modified duration is the price
                                          sensitivity and the percentage change
                                          in price for a unit change in yield
                                        </span>
                                      </p>
                                    </div>
                                    {/* <h6> Modified Duration</h6> */}
                                    <li>
                                      <span>{(ModifiedDuration).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} 
                                        {FundCode === "FF" ||
                                        FundCode === "IF" ||
                                        FundCode === "SD" ||
                                        FundCode === "LD" ||
                                        FundCode === "AA" ||
                                        FundCode === "BF"
                                          ? " Years"
                                          : FundCode === "LF" ||
                                              FundCode === "ON"
                                            ? " Days"
                                            : ""}
                                      </span>
                                    </li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                                {YTM != null ? (
                                  <ul className="Hoverul">
                                    <div className="sub-head text-wrap">
                                      <p className="hover-fund tooltip-align">
                                        YTM
                                        <span className="hover-text-summary">
                                          The Yield to Maturity or the YTM is
                                          the rate of return anticipated on a
                                          bond if held until maturity. YTM is
                                          expressed as an annual rate. The YTM
                                          factors in the bond’s current market
                                          price, par value, coupon interest rate
                                          and time to maturity
                                        </span>
                                      </p>
                                    </div>
                                    {/* <h6> YTM</h6> */}
                                    <li>
                                      <span>{(YTM).toLocaleString("en-IN", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}%</span>
                                    </li>
                                  </ul>
                                ) : (
                                  ""
                                )}
                              </div>
                            ),
                          )
                        ) : (
                          <h6
                            className="errorMsg"
                            style={{
                              top: "50%",
                              fontSize: "17px",
                            }}
                          >
                            Portfolio will reflect when disclosed
                          </h6>
                        )}
                      </>
                    )}
                  </div>
                )}
                {/* {loadingshow ? <div className="textcentervertex">
                                    <img src={animation} alt="Loading" />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                } */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductPortfolio;
